export const AUTH_TOKEN = "kimulti_cc_auth_token";
export const AUTH_PROFILE = "kimulti_cc_auth_profile";
export const AUTH_TOKEN_OTP = "kimulti_cc_otp_token";
